import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import World from "@frog/source/models/World.js"

import convertOldChapterScripting from "@frog/source/data/games/hero/convertOldChapterScripting.js"

export default {
    "slug": "upgrade-cleric",
    "stage": {
        "image": require("./image.png"),
        "units": require("./units.json"),
        "world": World.parse({
            "encounters": require("./encounters.json"),
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
        }),
        "text": function(stage) {
            return "Defeat the bandits."
        },
        "conditions": convertOldChapterScripting({
            "1:end": [
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#1",
                        "position": {"x": 6, "y": 4},
                        "classKey": "archer",
                        "affiliation": "bad",
                        "maxhealth": 30,
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 5, "y": 4},
                    "classKey": "#1",
                },
            ],
            "3:end": [
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#2",
                        "position": {"x": 6, "y": 6},
                        "classKey": "berserker",
                        "affiliation": "bad",
                        "maxhealth": 50,
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 5, "y": 6},
                    "classKey": "#2",
                }
            ],
        }, [
            {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
            {"type": "FinishLocation", "locationKey": "A"},
        ])
    },
}

// // https://serenesforest.net/wp-content/uploads/2017/02/32.png
// "upgrade-cleric": {
//     "music": "hero",
//     "hasPreparation": false,
//     "map": {
//         "width": 6,
//         "height": 8,
//         "image": require("@frog/source/assets/images/hero-tactics/stages/river-greener.png"),
//         "tiles": [
//             {"position": {"x": 2, "y": 0}, "passable": false},
//             {"position": {"x": 3, "y": 0}, "passable": false},
//             {"position": {"x": 4, "y": 0}, "passable": false},
//             {"position": {"x": 5, "y": 0}, "passable": false},
//             {"position": {"x": 2, "y": 2}, "passable": false},
//             {"position": {"x": 3, "y": 2}, "passable": false},
//             {"position": {"x": 1, "y": 3}, "passable": false},
//             {"position": {"x": 2, "y": 3}, "passable": false},
//             {"position": {"x": 3, "y": 3}, "passable": false},
//             {"position": {"x": 1, "y": 4}, "passable": false},
//             {"position": {"x": 2, "y": 4}, "passable": false},
//             {"position": {"x": 3, "y": 4}, "passable": false},
//             {"position": {"x": 1, "y": 5}, "passable": false},
//             {"position": {"x": 2, "y": 5}, "passable": false},
//             {"position": {"x": 0, "y": 7}, "passable": false},
//             {"position": {"x": 1, "y": 7}, "passable": false},
//             {"position": {"x": 2, "y": 7}, "passable": false},
//             {"position": {"x": 0, "y": 0}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/house.png")},
//             {"position": {"x": 5, "y": 5}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             {"position": {"x": 4, "y": 7}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//             // {"position": {x: 4, y: 7}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/desert/objects/tent_red.png")},
//             // {"position": {x: 5, y: 5}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/desert/objects/tent_red.png")},
//         ]
//     },
//     "spawns": [
//         {"position": {"x": 1, "y": 1}, "affiliation": "good"},
//         {"position": {"x": 1, "y": 0}, "affiliation": "good"},
//         {"position": {"x": 1, "y": 2}, "affiliation": "good"},
//         {"position": {"x": 0, "y": 2}, "affiliation": "good"},
//         {"position": {"x": 4, "y": 1}, "affiliation": "bad", "classKey": "berserker"},
//         {"position": {"x": 4, "y": 6}, "affiliation": "bad", "classKey": "berserker"},
//         {"position": {"x": 3, "y": 5}, "affiliation": "bad", "classKey": "archer"},
//     ],
//     "events": {
//         "1:end": [
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#1",
//                     "position": {"x": 6, "y": 4},
//                     "classKey": "archer",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 4},
//                 "classKey": "#1",
//             },
//         ],
//         "3:end": [
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#2",
//                     "position": {"x": 6, "y": 6},
//                     "classKey": "berserker",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 6},
//                 "classKey": "#2",
//             }
//         ],
//     },
//     "afterVictory": [
//         {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
//         {"type": "FinishLocation", "locationKey": "A"},
//     ],
//     "nextUrl": "/games/hero/chapters/defeat-boss",
// },
